import { render, staticRenderFns } from "./manage-statuses.vue?vue&type=template&id=3d96b5f2"
import script from "./manage-statuses.vue?vue&type=script&lang=js"
export * from "./manage-statuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports